module.exports = __webpack_public_path__ + "media/images/service/c_2-de47cab10cc4e1c29f1cf91070727560.png";